import { render, staticRenderFns } from "./RequestButtons.vue?vue&type=template&id=13771045&"
import script from "./RequestButtons.vue?vue&type=script&lang=js&"
export * from "./RequestButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip}, component.options.components || {})
